import { Button } from '@mui/material';

import { PLAN_PAGE } from 'src/constants';
import { useSettingsPageRedirection } from 'src/legacy/components/Settings/useSettingsPageRedirection';
import { useRouteAccess } from 'src/routes/routeAccess';

export const UpgradeTooltipTitle = ({
  description,
}: {
  description: string;
}) => {
  const { routeAccess } = useRouteAccess();

  const { goToSettings: goToPlansSettings } = useSettingsPageRedirection(
    true,
    PLAN_PAGE.path,
  );

  const onUpgradePlan = () => goToPlansSettings();

  return (
    <span>
      <span>{description} </span>
      {routeAccess.allowSettingsPlanPage ? (
        <Button
          variant="text"
          onClick={onUpgradePlan}
          className="underline text-white text-[0.75rem] hover:underline"
        >
          upgrade your plan.
        </Button>
      ) : (
        <span>, ask your account admin to upgrade your plan</span>
      )}
    </span>
  );
};
